<template>
  <div class="membership-plans app-page">
    <div class="plans-container">
      <div v-if="loading" class="loading">
        <div class="spinner"></div>
        <p>加载中...</p>
      </div>

      <div v-if="error" class="error-message">{{ error }}</div>

      <div class="plan-cards">
        <!-- 月会员 -->
        <div class="plan-card">
          <div class="plan-header">
            <span class="plan-emoji">🌙</span>
            <h2 class="plan-name">月会员</h2>
            <div class="price">
              <span class="currency">¥</span>
              <span class="amount">30</span>
              <span class="period">/月</span>
            </div>
          </div>
          <div class="plan-features">
            <ul>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限发起匹配</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限查看推荐好友</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限制聊天</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>专属会员标识</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>优先匹配</li>
            </ul>
          </div>
          <button class="buy-btn" @click="createMembership(1)">立即开通</button>
        </div>

        <!-- 季会员 -->
        <div class="plan-card popular">
          <div class="plan-badge">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            最受欢迎
          </div>
          <div class="plan-header">
            <span class="plan-emoji">🌟</span>
            <h2 class="plan-name">季会员</h2>
            <div class="price">
              <span class="currency">¥</span>
              <span class="amount">80</span>
              <span class="period">/3个月</span>
            </div>
            <div class="save-tag">节省¥10</div>
          </div>
          <div class="plan-features">
            <ul>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限发起匹配</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限查看推荐好友</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限制聊天</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>专属会员标识</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>优先匹配</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>每月免费礼物2个</li>
            </ul>
          </div>
          <button class="buy-btn popular-btn" @click="createMembership(2)">立即开通</button>
        </div>

        <!-- 年会员 -->
        <div class="plan-card">
          <div class="plan-header">
            <span class="plan-emoji">👑</span>
            <h2 class="plan-name">年会员</h2>
            <div class="price">
              <span class="currency">¥</span>
              <span class="amount">288</span>
              <span class="period">/12个月</span>
            </div>
            <div class="save-tag">节省¥72</div>
          </div>
          <div class="plan-features">
            <ul>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限发起匹配</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限查看推荐好友</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>无限制聊天</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>专属会员标识</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>优先匹配</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>每月免费礼物5个</li>
              <li class="feature"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>专属客服</li>
            </ul>
          </div>
          <button class="buy-btn" @click="createMembership(3)">立即开通</button>
        </div>
      </div>

      <div class="membership-benefits">
        <h3 class="benefits-section-title">会员特权详情</h3>
        <div class="benefits-grid">
          <div class="benefit-item">
            <div class="benefit-icon-wrap">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 12l2 2 4-4"/></svg>
            </div>
            <div class="benefit-info">
              <h4>无限匹配</h4>
              <p>非会员每日限3次匹配，会员无限制</p>
            </div>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon-wrap">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <div class="benefit-info">
              <h4>无限推荐</h4>
              <p>非会员每日限3次查看推荐，会员无限制</p>
            </div>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon-wrap">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            </div>
            <div class="benefit-info">
              <h4>无限聊天</h4>
              <p>非会员限3个新聊天对象，会员无限制</p>
            </div>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon-wrap">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            </div>
            <div class="benefit-info">
              <h4>会员标识</h4>
              <p>个人主页显示专属会员标识</p>
            </div>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon-wrap">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="12" rx="2"/><path d="M5 8V6a2 2 0 012-2h10a2 2 0 012 2v2"/></svg>
            </div>
            <div class="benefit-info">
              <h4>免费礼物</h4>
              <p>定期赠送免费虚拟礼物</p>
            </div>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon-wrap">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
            </div>
            <div class="benefit-info">
              <h4>优先匹配</h4>
              <p>匹配队列中优先展示</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import membershipApi from '@/api/membership';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

const router = useRouter();
const loading = ref(false);
const error = ref('');
const currentUserId = ref(localStorage.getItem('userId') ? Number(localStorage.getItem('userId')) : null);

const createMembership = async (membershipType) => {
  if (!currentUserId.value) {
    ElMessage.error('请先登录');
    router.push('/login');
    return;
  }

  try {
    loading.value = true;
    error.value = '';

    const res = await membershipApi.createMembershipOrder(currentUserId.value, membershipType);
    console.log('调用生成订单接口返回---'+res.data.code)
    if (res.data.code == 200) {
      // 跳转到支付页面
      router.push({
        path: '/membership/pay',
        query: { orderNo: res.data.data.orderNo }
      });
    } else {
      ElMessage.error(res.data.msg || '创建订单失败');
    }
  } catch (err) {
    error.value = err.response?.data?.msg || '创建会员订单失败';
    ElMessage.error(error.value);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>

.plans-container {
  width: 100%;
}

.loading {
  text-align: center;
  padding: 60px 0;
}

.loading p {
  margin-top: 16px;
  color: var(--app-text-secondary);
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  border: 3px solid var(--app-border-light);
  border-top-color: var(--app-color-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.08);
  padding: 14px 20px;
  border-radius: var(--app-radius-md);
  text-align: center;
  margin-bottom: 1rem;
  border: 1px solid rgba(231, 76, 60, 0.15);
}

/* Pricing cards */
.plan-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 48px;
}

.plan-card {
  background: var(--app-bg-card);
  border-radius: var(--app-radius-xl);
  box-shadow: var(--app-shadow-card);
  border: 2px solid var(--app-border-subtle);
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
}

.plan-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--app-shadow-card-hover);
  border-color: rgba(255, 126, 126, 0.2);
}

.plan-card.popular {
  border-color: var(--app-color-primary);
  transform: scale(1.03);
  box-shadow: 0 8px 30px rgba(255, 126, 126, 0.15);
}

.plan-card.popular:hover {
  transform: scale(1.03) translateY(-6px);
}

.plan-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  background: var(--app-gradient-primary);
  color: white;
  padding: 6px 14px;
  font-size: 0.8125rem;
  font-weight: 600;
  border-radius: var(--app-radius-full);
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 2;
  box-shadow: 0 4px 12px rgba(255, 126, 126, 0.35);
}

.plan-header {
  padding: 28px 24px 20px;
  text-align: center;
  position: relative;
}

.plan-emoji {
  font-size: 2.5rem;
  display: block;
  margin-bottom: 8px;
}

.plan-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 16px;
}

.price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
}

.currency {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--app-color-primary);
  align-self: flex-start;
  margin-top: 4px;
}

.amount {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--app-color-primary);
  line-height: 1;
}

.period {
  font-size: 0.9375rem;
  color: var(--app-text-muted);
  align-self: flex-end;
  margin-bottom: 6px;
}

.save-tag {
  display: inline-block;
  margin-top: 10px;
  padding: 3px 12px;
  background: rgba(255, 126, 126, 0.1);
  color: var(--app-color-primary);
  border-radius: var(--app-radius-full);
  font-size: 0.8125rem;
  font-weight: 500;
}

.plan-features {
  padding: 0 24px 20px;
  flex: 1;
}

.plan-features ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature {
  padding: 10px 0;
  border-bottom: 1px solid var(--app-border-light);
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--app-text-secondary);
  font-size: 0.875rem;
}

.feature:last-child {
  border-bottom: none;
}

.feature svg {
  color: #2ecc71;
  flex-shrink: 0;
}

.buy-btn {
  width: calc(100% - 48px);
  margin: 0 24px 24px;
  padding: 14px;
  background: var(--app-bg-soft);
  color: var(--app-color-primary);
  border: 1px solid var(--app-border-light);
  border-radius: var(--app-radius-lg);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.buy-btn:hover {
  background: var(--app-color-primary-soft);
  border-color: var(--app-color-primary);
}

.buy-btn.popular-btn {
  background: var(--app-gradient-primary);
  color: white;
  border: none;
  box-shadow: 0 4px 15px rgba(255, 126, 126, 0.35);
}

.buy-btn.popular-btn:hover {
  box-shadow: 0 6px 20px rgba(255, 126, 126, 0.5);
  transform: translateY(-2px);
}

/* Benefits section */
.membership-benefits {
  background: var(--app-bg-card);
  border-radius: var(--app-radius-xl);
  padding: 32px;
  box-shadow: var(--app-shadow-card);
  border: 1px solid var(--app-border-subtle);
}

.benefits-section-title {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--app-border-light);
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px;
  border-radius: var(--app-radius-lg);
  background: var(--app-bg-soft);
  border: 1px solid var(--app-border-subtle);
  transition: all 0.25s ease;
}

.benefit-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--app-shadow-card);
}

.benefit-icon-wrap {
  width: 42px;
  height: 42px;
  border-radius: var(--app-radius-md);
  background: var(--app-gradient-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}

.benefit-info h4 {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 4px;
}

.benefit-info p {
  font-size: 0.8125rem;
  color: var(--app-text-secondary);
  margin: 0;
  line-height: 1.5;
}

@media (max-width: 1024px) {
  .plan-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .plan-card.popular {
    transform: none;
  }

  .plan-card.popular:hover {
    transform: translateY(-6px);
  }

  .benefits-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .plan-cards {
    grid-template-columns: 1fr;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .membership-benefits {
    padding: 20px 16px;
  }
}
</style>
